import { render, staticRenderFns } from "./BoxOfficeDaily.vue?vue&type=template&id=5228de84&scoped=true&"
import script from "./BoxOfficeDaily.vue?vue&type=script&lang=js&"
export * from "./BoxOfficeDaily.vue?vue&type=script&lang=js&"
import style0 from "./BoxOfficeDaily.vue?vue&type=style&index=0&id=5228de84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228de84",
  null
  
)

export default component.exports